<template>
    <div class='cnt_box'>
        <!-- 顶部title -->
        <div class="cnt_top_box" :style="{
            'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
            'backgroundColor': '#f5f5f5' // 添加备用背景色
        }">
            <div class="flex">
                <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
                <div class="right_top_box">
                    <div class="right_top_txt">{{ $t('PoweredbyMVGX') }}</div>
                    <!-- <div class="right_top_txt_shu">|</div>
                    <Kefu :sn='sn'></Kefu> -->
                </div>
            </div>
            <img class="jindu" v-if="$i18n.locale == 'en'" src="../assets/img/cnt_top_jindu.png" alt="">
            <div v-else>
                <img class="jindu1" v-if="carbonFootprint" src="../assets/img/iscou.png" alt="">
                <img class="jindu1" v-else src="../assets/img/nocou.png" alt="">
            </div>
            <!-- <img class="jindu"  src="../assets/img/cnt_top_jindu_cn.png" alt=""> -->

            <div class="cnt_flex">
                <div class="cnt_num_box">
                    <p>{{ carbonFootprint }}</p>
                    <span>kgCO₂e</span>
                </div>
                <div class="cnt_top_title">{{ $t('TotalCarbonFootprint') }}</div>
                <div class="cnt_top_div">
                    <div class="border_box margin_left_box">
                        <el-date-picker v-model="datetonnes" type="date" :picker-options="pickerOptions"
                            @change="changeDate()" :placeholder="$t('date')" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                    <div class="border_box border_box_right">
                        <div class="txt_border_box">{{ carConSum }}</div>
                        <div class="txt_border_tit">kgCO₂e</div>
                        <img @click="gotoList()" src="../assets/img/history.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部出行行程 -->
        <div class="cnt_banner">
            <!-- 顶部图片 -->
            <div class="top_title_box">
                {{ $t('NetZeroDiary') }}
            </div>
            <!-- 步骤条 -->
            <div class="step_box">
                <!-- <div class="step_img">
                    <img src="../assets/img/dian.png" alt="">
                </div>
                <div class="top_step_txt">Departing</div> -->
                <div class="step_box_title">{{ $t('Trips') }}</div>
                <!-- 循环数据 -->
                <div class="chanoe_box" v-for="(item, index) in formData.departingData" :key="index">
                    <div class="formto_box">
                        <div class="xu_txt">{{ index + 1 }}</div>
                        <div class="form_txt" :class="item.startCity == '' ? 'color_txt' : ''"
                            @click="changeFromToDrawer('from', index, 1, item.startCity)">{{ item.startCity ?
                                item.startCity.split(',')[0] : $t('From')}}</div>
                        <div class="chu_img" @click="changeTravelTool(item.vehicle, index, 1)">
                            <img v-if="item.vehicle == 10" class="feiji_img" src="../assets/img/feiji_xuxian.png"
                                alt="">
                            <!-- <img v-if="item.transport == 1" class="walk_img" src="../assets/img/walk1.png" alt=""> -->
                            <img v-if="item.vehicle == 2" class="car1_img" src="../assets/img/Car1.png" alt="">
                            <img v-if="item.vehicle == 4" class="motocycle1_img" src="../assets/img/ElectricMotor_2.png"
                                alt="">
                            <!-- <img v-if="item.transport == 4" class="car3_img" src="../assets/img/Car3.png" alt=""> -->
                            <img v-if="item.vehicle == 5" class="motocycle1_img" src="../assets/img/Motocycle1.png"
                                alt="">
                            <img v-if="item.vehicle == 9" class="bus1_img" src="../assets/img/Tram_2.png" alt="">
                            <img v-if="item.vehicle == 6" class="bus1_img" src="../assets/img/bus1.png" alt="">
                            <img v-if="item.vehicle == 7" class="rains1_img" src="../assets/img/City Trains1.png"
                                alt="">
                            <img v-if="item.vehicle == 8" class="ferry1_img" src="../assets/img/Sea ferry1.png" alt="">
                            <!-- <img v-if="item.transport == 5" class="nter_city_img" src="../assets/img/nter-city Trains1.png" alt=""> -->
                        </div>
                        <div class="to_txt" :class="item.endCity == '' ? 'color_txt' : ''"
                            @click="changeFromToDrawer('to', index, 1, item.endCity)">{{ item.endCity ?
                                item.endCity.split(',')[0] : $t('To')}}</div>
                    </div>
                    <div class="fenge_box">
                        <el-divider></el-divider>
                        <el-row type="flex" justify="end" class="fenge_box_flex">
                            <el-col :span="12" class="txt_align txt_title">{{ $t('CarbonFootprint') }}</el-col>
                            <el-col :span="4" class="txt_align txt_txt">{{ item.exactAmount }}</el-col>
                            <el-col :span="4" class="fenge_img txt_align">
                                <img src="../assets/img/tianjia-2.png" alt="" @click="removedepartingData(index)">
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </div>
                </div>
                <!-- 增加和删除 -->
                <div class="addrem_box">

                    <el-row type="flex" justify="space-around" class="img_flex_box">
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/City_1.png" @click="adddepartingData(7)" alt="">
                            <div class="se_tx">{{ $t('CityTrains') }}</div>
                        </el-col>
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/car_1.png" @click="adddepartingData(2)" alt="">
                            <div class="se_tx">{{ $t('Car_Taxi') }}</div>
                        </el-col>
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/Electric_1.png" @click="adddepartingData(4)" alt="">
                            <div class="se_tx">{{ $t('e_Bike') }}</div>
                        </el-col>
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/Motocycle_1.png" @click="adddepartingData(5)" alt="">
                            <div class="se_tx">{{ $t('Motorcycle') }}</div>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="space-around" class="img_flex_box">
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/Tram_1.png" @click="adddepartingData(9)" alt="">
                            <div class="se_tx">{{ $t('Tram') }}</div>
                        </el-col>
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/Bus_1.png" @click="adddepartingData(6)" alt="">
                            <div class="se_tx">{{ $t('Bus') }}</div>
                        </el-col>
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/Airplane.png" @click="adddepartingData(10)" alt="">
                            <div class="se_tx">{{ $t('Airplane') }}</div>
                        </el-col>

                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/Sea_1.png" @click="adddepartingData(8)" alt="">
                            <div class="se_tx">{{ $t('SeaFerry') }}</div>
                        </el-col>
                    </el-row>
                </div>

            </div>



            <!-- 底部出行详细 -->
            <div class="step_box">
                <div class="step_box_title">
                    {{ $t('Stays') }}
                </div>
                <!-- 循环数据 -->
                <div class="chanoe_box" v-for="(item, index) in formData.stayData" :key="index">
                    <div class="formto_box">
                        <div class="xu_txt">{{ index + 1 }}</div>
                        <div class="form_txt ipt_btm_box">
                            <el-input v-model="item.stayCity" @input="changeStay(item, index)"
                                :placeholder="$t('City')"></el-input>
                        </div>
                        <div class="chu_img margin_mg_box" @click="changeTravelToolstay(item.vehicle, index, 1)">
                            <img v-if="item.vehicle == 12" class="yonghu_img" src="../assets/img/danrenchuang.png"
                                alt="">
                            <img v-if="item.vehicle == 13" class="yonghu_img" src="../assets/img/shuangrenchuang.png"
                                alt="">
                        </div>
                        <div class="to_txt ipt_btm_box txt_ipt">
                            <el-input v-model="item.stayAmount" oninput="value=value.replace(/[^\d]/g,'')"
                                @input="changeStay(item, index)" placeholder="0"></el-input>
                            <div class="nig_txt">{{ $t('Night') }}</div>
                        </div>
                    </div>
                    <div class="fenge_box">
                        <el-divider></el-divider>
                        <el-row type="flex" justify="end" class="fenge_box_flex">
                            <el-col :span="12" class="txt_align txt_title">{{ $t('CarbonFootprint') }}</el-col>
                            <el-col :span="4" class="txt_align txt_txt">{{ item.exactAmount }}</el-col>
                            <el-col :span="4" class="fenge_img txt_align">
                                <img src="../assets/img/tianjia-2.png" @click="removestayData(index)" alt="">
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </div>
                </div>
                <!-- 增加和删除 -->
                <div class="addrem_box">

                    <el-row type="flex" justify="start" class="img_flex_box">
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/bed.png" @click="addstayData(12)" alt="">
                            <div class="se_tx">{{ $t('bed') }}</div>
                        </el-col>
                        <el-col :span="6" class="se_box">
                            <img src="../assets/img/beds.png" @click="addstayData(13)" alt="">
                            <div class="se_tx">{{ $t('beds') }}</div>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="start">
                        <el-col>
                            <div class="se_tx" style="padding: 20px 0 0 20px;font-size: 12px;font-family: Century Gothic;color: #8F8F8F;">{{ $t('Addaccommodationbeds') }}</div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <!-- 底部按钮 -->
            <div class="btm_btns">
                <div @click="computCon()">{{ $t('CalculateMyCarbonFootprint') }}</div>
            </div>
            <div class="btm_btn">
                <!-- <div @click="submit()">Neutralize My Carbon Footprint</div> -->
            </div>
        </div>


        <!-- 行程弹出框 -->
        <el-drawer title="" :visible.sync="drawerFromTo" direction="btt" size="270px" :wrapper-closable="false"
            :before-close="handleClose" custom-class="drawer_formto" ref="drawerFromTo">
            <div class="drawer_banner">
                <div class="drawer_title">{{ drawerTitle }}</div>
                <div class="ipt_box">
                    <el-autocomplete v-model="formdata" :fetch-suggestions="querySearchAsync"
                        :popper-append-to-body="false" :trigger-on-focus="false" :placeholder="drawerPlace"
                        @select.native="handleSelect">
                    </el-autocomplete>
                </div>
                <div class="btn_box">
                    <div @click="changeFormToDrawer">{{ $t('OK') }}</div>
                </div>
            </div>
        </el-drawer>

        <!-- 交通工具弹出框 -->
        <el-drawer title="" :visible.sync="travelToolDrawer" direction="btt" size="37.8125rem" :wrapper-closable="false"
            :before-close="handleCloseTool" custom-class="drawer_formto" ref="travelTool">
            <div class="drawer_banner">
                <div class="drawer_title">{{ $t('ChooseTransport') }}</div>
                <div class="drawer_content">
                    <div class="diawer_flex" @click="changeTraverTool(7)">
                        <div class="diawer_flex_flex">
                            <img class="rain_img" src="../assets/img/City Trains.png" alt="">
                            <div>{{ $t('CityTrains') }}</div>
                        </div>
                        <img v-if="travelTool == 7" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>

                    <div class="diawer_flex" @click="changeTraverTool(2)">
                        <div class="diawer_flex_flex">
                            <img class="car_img" src="../assets/img/Car.png" alt="">
                            <div>{{ $t('Car_Taxi') }}</div>
                        </div>
                        <img v-if="travelTool == 2" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>


                    <div class="diawer_flex" @click="changeTraverTool(4)">
                        <div class="diawer_flex_flex">
                            <img class="car2_img" src="../assets/img/e-Bike_new.png" alt="">
                            <div>{{ $t('e_Bike') }}</div>
                        </div>
                        <img v-if="travelTool == 4" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>

                    <div class="diawer_flex" @click="changeTraverTool(5)">
                        <div class="diawer_flex_flex">
                            <img class="moto_img" src="../assets/img/Motocycle.png" alt="">
                            <div>{{ $t('Motorcycle') }}</div>
                        </div>
                        <img v-if="travelTool == 5" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>

                    <div class="diawer_flex" @click="changeTraverTool(9)">
                        <div class="diawer_flex_flex">
                            <img class="nter_img" src="../assets/img/Tram_new.png" alt="">
                            <div>{{ $t('Tram') }}</div>
                        </div>
                        <img v-if="travelTool == 9" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>

                    <div class="diawer_flex" @click="changeTraverTool(6)">
                        <div class="diawer_flex_flex">
                            <img class="bus_img" src="../assets/img/Bus.png" alt="">
                            <div>{{ $t('Bus') }}</div>
                        </div>
                        <img v-if="travelTool == 6" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>



                    <div class="diawer_flex" @click="changeTraverTool(10)">
                        <div class="diawer_flex_flex">
                            <img class="feiji_img" src="../assets/img/feiji.png" alt="">
                            <div>{{ $t('Airplane') }}</div>
                        </div>
                        <img v-if="travelTool == 10" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>

                    <div class="diawer_flex" @click="changeTraverTool(8)">
                        <div class="diawer_flex_flex">
                            <img class="ferry_img" src="../assets/img/Sea ferry.png" alt="">
                            <div>{{ $t('SeaFerry') }}</div>
                        </div>
                        <img v-if="travelTool == 8" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>
                </div>
            </div>
        </el-drawer>

        <!-- 住宿弹出框 -->
        <el-drawer title="" :visible.sync="travelToolDrawerstay" direction="btt" size="250px" :wrapper-closable="false"
            :before-close="handleCloseTool" custom-class="drawer_formto" ref="travelToolstay">
            <div class="drawer_banner">
                <div class="drawer_title">{{ $t('IndividualorGroupAccomodation') }}</div>
                <div class="drawer_content">
                    <div class="diawer_flex" @click="changeTraverToolstay(12)">
                        <div class="diawer_flex_flex">
                            <img class="car_img" src="../assets/img/danrenchuang.png" alt="">
                            <div>{{ $t('bed') }}</div>
                        </div>
                        <img v-if="travelToolstay == 12" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>

                    <div class="diawer_flex" @click="changeTraverToolstay(13)">
                        <div class="diawer_flex_flex">
                            <img class="car_img" src="../assets/img/shuangrenchuang.png" alt="">
                            <div>{{ $t('beds') }}</div>
                        </div>
                        <img v-if="travelToolstay == 13" class="duihao_img" src="../assets/img/xuanzhong.png" alt="">
                    </div>
                    <el-divider></el-divider>
                </div>
            </div>
        </el-drawer>

        <!-- 提交弹出框 -->
        <el-dialog :title="$t('Notice')" :visible.sync="centerDialogVisible" width="95%" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" center>
            <div>{{ $t('Pleasenotethatonceconfirmedthe') }} </div>
            <div>{{ $t('informationsavedcannolongerbemodified') }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_cancel" @click="centerDialogVisible = false">{{ $t('Cancel') }}</div>
                <div class="btn_confirm" @click="submitAll">{{ $t('Confirm') }}</div>
            </span>
        </el-dialog>

        <!-- 时间为空弹出框 -->
        <el-dialog title="" :visible.sync="dailogDate" :close-on-click-modal="false" width="95%" :show-close="false"
            center>
            <div>{{ $t('Pleaseselectadate') }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_cancel" @click="dailogDate = false">{{ $t('Close') }}</div>
            </span>
        </el-dialog>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import cnt from '@/api/cnt'
import { getDefaultDate } from '@/util/date.js'
import Kefu from '@/components/kefu.vue'
export default {
    name: 'cnt',
    // import引入的组件需要注入到对象中才能使用
    components: { Kefu },
    data() {
        // 这里存放数据
        return {
            sn: '',
            checked: true,
            dailogDate: false,
            btmStepAmain: true,
            centerDialogVisible: false,
            datetonnes: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },
            travelTool: 10,
            travelToolstay: 12,
            carbonFootprint: 0,
            removeCarBon: 0,
            sumhotelNight: 0,
            departindex: '',
            departindexstay: '',
            formdata: '',
            formText: '',
            travelToolType: 1,
            travelToolTypestay: 1,
            drawerType: 'from',
            timeout: null,
            drawerFromTo: false,
            travelToolDrawer: false,
            travelToolDrawerstay: false,
            submitBool: false,
            drawerTitle: '',
            drawerPlace: '',
            departType: '',
            carConSum: 0,
            formData: {
                departingData: [
                    {
                        startCity: '',
                        endCity: '',
                        vehicle: 10,
                        exactAmount: 0,
                    },
                ],
                stayData: [
                    {
                        stayCity: '',
                        stayAmount: '',
                        exactAmount: 0,
                        vehicle: 12,
                    }
                ],
            },
            config: '',
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        // this.getTravelRecord()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.sn = this.$route.query.sn
        this.datetonnes = this.getDefaultDate(Date.now())
        this.getCarConNum()
        this.getCarConListNum()
        // this.getUserEvent(1,1)
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
    // 方法集合
    methods: {
        getDefaultDate: getDefaultDate,
        //用户行为分析
        getUserEvent(val, type, sum) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
                carbonFootprintQuantity: sum ? sum : 0
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        //切换交通工具
        changeTravelTool(val, index, type) {
            this.departindex = index
            this.travelTool = val
            this.travelToolType = type
            this.travelToolDrawer = !this.travelToolDrawer
        },
        //切换交通工具
        changeTraverTool(val) {
            this.travelTool = val
            this.$set(this.formData.departingData[this.departindex], 'vehicle', val);
            this.computCarCon(this.formData.departingData[this.departindex], 1, this.departindex)
            this.$forceUpdate();
            this.$refs.travelTool.closeDrawer()
        },
        //切换住宿
        changeTravelToolstay(val, index, type) {
            this.departindexstay = index
            this.travelToolstay = val
            this.travelToolTypestay = type
            this.travelToolDrawerstay = !this.travelToolDrawerstay
        },
        //切换住宿
        changeTraverToolstay(val) {
            this.travelToolstay = val
            this.$set(this.formData.stayData[this.departindexstay], 'vehicle', val);
            this.computCarCon(this.formData.stayData[this.departindexstay], 2, this.departindexstay)
            this.$forceUpdate();
            this.$refs.travelToolstay.closeDrawer()
        },
        getCarConListNum() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            let params = {
                start: this.datetonnes,
                end: this.datetonnes,
                userId: user.id,
            }
            cnt.getCarConListNum(res => {
                console.log(res)
                if (res.code == 200) {
                    this.carConSum = res.data.historyTotal
                }
            }, params)
        },
        changeDate() {
            console.log(1)
            this.getCarConListNum()
            this.formData.departingData = [{
                startCity: '',
                endCity: '',
                vehicle: 10,
                exactAmount: 0,
            }]
            this.formData.stayData = [{
                stayCity: '',
                stayAmount: '',
                exactAmount: 0,
                vehicle: 12,
            }]
        },
        getTravelRecord() {
            cnt.getTravelRecord(res => {
                if (!res) {
                    this.$router.push({ path: '/result', query: { sn: this.sn } })
                } else if (res.snStatus == 1) {
                    this.$router.push({ path: "/info", query: { sn: this.sn } });
                } else if (res.snStatus == 2) {
                    this.$router.push({ path: '/resultCard', query: { sn: this.sn } })
                } else if (res.snStatus == null) {

                }
            }, { sn: this.sn })
        },
        //行程弹出框
        handleClose(done) {
            done()
        },
        //跳转列表
        gotoList() {
            this.$router.push({ path: "/carconList", query: { sn: this.sn } });
        },
        //弹出行程弹出框
        changeFromToDrawer(type, index, types, str) {
            this.drawerType = type
            this.departindex = index
            this.departType = types
            if (this.drawerType == 'from') {
                this.drawerTitle = this.$t('Departure');
                this.drawerPlace = this.$t('Leavingfrom')
            } else {
                this.drawerTitle = this.$t('Destination')
                this.drawerPlace = this.$t('Goingto')
            }
            if (str == 'From') {
                str = ''
            }
            if (str == 'To') {
                str = ''
            }
            this.formdata = str
            this.drawerFromTo = true
        },
        //目的地远程搜索
        querySearchAsync(queryString, cb) {
            let results = [];
            if (queryString == '') {
                cb(results)
            } else {
                let params = {
                    text: queryString,
                    outFields: '*',
                    maxSuggestions: 5,
                    f: 'json'
                }
                //远程搜索获取地址
                cnt.getFromTo(response => {
                    if (response.suggestions) {
                        let arr = response.suggestions
                        for (let i = 0; i < arr.length; i++) {
                            const ele = arr[i]
                            results.push({
                                value: ele.text.replace(/Dubai, ARE/g, "Dubai"),
                                id: ele.magicKey
                            })
                        }
                        cb(results)
                    } else {
                        results = []
                        cb(results)
                    }
                }, params)
            }
        },
        //选择目的地
        handleSelect(item) {
            console.log(item, this.formdata)
            // this.formdata = item.id
            // this.formText = item.text
        },
        //确定选择目的地
        changeFormToDrawer() {
            //判断是出发地还是目的地
            if (this.drawerType == 'from') {
                this.$set(this.formData.departingData[this.departindex], 'startCity', this.formdata)
                this.$forceUpdate();
            } else {
                this.$set(this.formData.departingData[this.departindex], 'endCity', this.formdata)
                this.$forceUpdate();
            }
            this.computCarCon(this.formData.departingData[this.departindex], 1, this.departindex)
            this.$refs.drawerFromTo.closeDrawer()
        },
        //关闭弹出框
        handleCloseTool(done) {
            done()
        },
        //添加一条行程
        adddepartingData(val) {
            this.formData.departingData.push({
                startCity: '',
                endCity: '',
                vehicle: val,
                exactAmount: 0,
            },)
            this.$forceUpdate();
        },
        //删除一条行程
        removedepartingData(index) {
            if (this.formData.departingData.length > 1) {
                this.formData.departingData.splice(index, 1)
                // this.computAllCarCon()
            }
        },
        //添加一条住宿单
        addstayData(type) {
            this.formData.stayData.push({
                stayCity: '',
                stayAmount: '',
                exactAmount: 0,
                vehicle: type,
            })
            this.$forceUpdate();
        },
        //删除一条住宿单
        removestayData(index) {
            if (this.formData.stayData.length > 1) {
                this.formData.stayData.splice(index, 1)
                // this.computAllCarCon()
            }
        },
        //获取住宿城市和天数
        changeStay(row, index) {
            console.log(row)
            if (row.stayCity && row.stayAmount > 0) {
                this.computCarCon(row, 2, index)
            }
        },
        //计算单条碳排放量
        computCarCon(row, type, index) {
            // let user = JSON.parse(sessionStorage.getItem('user'))
            let params = {
                endCity: row.endCity,
                startCity: row.startCity,
                vehicle: type == 1 ? row.vehicle : row.vehicle,
                stayAmount: type == 1 ? '' : row.stayAmount,
                stayCity: type == 1 ? '' : row.stayCity,
            }
            //如果是行程
            if (type == 1) {
                if (params.endCity && params.startCity) {
                    cnt.carbonFootPrint(res => {
                        if (res.code == 200) {
                            this.$set(this.formData.departingData[index], 'exactAmount', res.data.carbonFootprint)
                            this.$forceUpdate();
                            // this.computAllCarCon()
                        } else {
                            this.$set(this.formData.departingData[index], 'exactAmount', 0)
                            this.$forceUpdate();
                        }
                    }, params)
                }
            } else {
                //如果是住宿
                cnt.carbonFootPrint(res => {
                    if (res.code == 200) {
                        this.$set(this.formData.stayData[index], 'exactAmount', res.data.carbonFootprint)
                        this.$forceUpdate();
                        // this.computAllCarCon()
                    } else {
                        this.$set(this.formData.stayData[index], 'exactAmount', 0)
                        this.$forceUpdate();
                    }

                }, params)
            }
            console.log(123, params)

        },
        //计算碳排放
        computCon() {
            this.getUserEvent(2, 3)
            this.centerDialogVisible = true
        },
        //提交行程
        submit() {
            // let user = JSON.parse(sessionStorage.getItem('user'))
            // let params = {
            //     userId:user.id,
            //     sn:this.sn
            // }
            // cnt.changeneutralize(response =>{
            //     if(response.code == 200){
            // this.centerDialogVisible = false
            this.getUserEvent(2, 4)
            this.$router.push({ path: '/info', query: { sn: this.sn } })
            // }
            // },params)
        },
        computAllCarCon() {
            let arr1 = this.formData.departingData
            let arr2 = this.formData.stayData
            let sum1 = 0
            let sum2 = 0
            for (let i = 0; i < arr1.length; i++) {
                sum1 += arr1[i].exactAmount
            }
            for (let j = 0; j < arr2.length; j++) {
                sum2 += arr2[j].exactAmount
            }
            this.carConSum = sum1 + sum2
        },
        submitAll() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            let params = {
                date: this.datetonnes,
                userId: user.id,
                sn: user.username,
                tripRecordList: this.formData.departingData,
                stayRecordList: this.formData.stayData,
            }
            if (!params.date) {
                this.dailogDate = true
                return
            }
            cnt.computCarCon(res => {
                if (res.code == 200) {
                    this.getCarConNum(1)
                    this.getCarConListNum()
                    this.formData.departingData = [{
                        startCity: '',
                        endCity: '',
                        vehicle: 10,
                        exactAmount: 0,
                    }]
                    this.formData.stayData = [{
                        stayCity: '',
                        stayAmount: '',
                        exactAmount: 0,
                    }]
                    // this.getUserEvent(2,7)
                    this.centerDialogVisible = false

                    this.$router.push({ path: '/info', query: { sn: this.sn } })
                } else {
                    this.$message.error(res.message)
                }
            }, params)

        },
        //获取碳排放总量
        getCarConNum(type) {
            let user = JSON.parse(sessionStorage.getItem('user'))
            cnt.getCarConNum(res => {
                console.log(res)
                if (res.code == 200) {
                    this.carbonFootprint = res.data
                    if (type == 1) {
                        this.getUserEvent(2, 7, res.data)
                    }
                }
            }, user.id)
        }
    }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 20px 0;
}

.cnt_box {
    width: 100%;
    height: 100%;
}

NaNpx_txt {
    font-size: 15px;
    font-family: Century Gothic;
    color: #4D94A0;
    line-height: 17px;
}

.cnt_top_box {
    width: 100%;
    // height: 338.5008px;
    height: 350px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    position: -webkit-fixed;
    position: fixed;
    top: 0;
    z-index: 99;

    .logo {
        width: auto;
    }

    .jindu {
        width: 333.5008px;
        height: 41.5008px;
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
    }

    .jindu1{
        width: auto;
        height: 41.5008px;
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
    }

    .right_top_box {
        display: flex;
        align-items: center;

        .right_top_txt {
            font-size: 12px;
            font-family: Century Gothic;
            color: #EDFFFE;
        }

        .right_top_txt_shu {
            margin: 0 12px;
            color: #EDFFFE;
        }
    }

    .cnt_top_div {
        width: 100%;
        min-height: 27px;
        border-radius: 20px 20px 0 0;
        background: #F3F4F6;
        position: absolute;
        bottom: -50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        // padding: 20px;
        .border_box {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 163px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 10px;
        }

        .margin_left_box {
            margin-top: 20px;
            margin-left: 20px;
            margin-bottom: 20px;
        }

        .border_box_right {
            margin-top: 20px;
            margin-right: 20px;
            margin-bottom: 20px;

            .txt_border_box {
                font-size: 15px;
                font-family: Arial-BoldMT, Arial;
                font-weight: 600;
                color: #303236;
            }

            .txt_border_tit {
                font-size: 14px;
                font-family: Century Gothic;
                color: #8F8F8F;
            }

            img {
                width: 16.5px;
                height: 17.5px;
            }
        }
    }

    .cnt_flex {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 40px;

        .cnt_num_box {
            display: flex;

            // padding-top: 60px;
            p {
                font-size: 49px;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #FFFFFF;
                line-height: 44px;
            }

            span {
                font-size: 12px;
                font-family: Century Gothic;
                color: #FFFFFF;
                margin: 24px 0 0 5px;
            }
        }

        .cnt_top_title {
            font-size: 13px;
            font-family: Century Gothic;
            color: #FFFFFF;
            margin-top: 4.5008px;
        }
    }

}

::v-deep .el-scrollbar {
    .el-scrollbar__bar {
        opacity: 1 !important;
    }
}

::v-deep .el-dialog {
    background: #FFFFFF;
    border-radius: 20px;
    margin-top: 30vh !important;

    .el-dialog__title {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303236;
        line-height: 25px;
    }

    .el-dialog__body {
        font-size: 15px;
        font-family: Century Gothic;
        color: #8F8F8F;
        line-height: 20px;
        text-align: center;
        padding: 1.5625rem .875rem 1.875rem !important;
    }

    .dialog-footer {
        display: flex;
        justify-content: center;

        .btn_cancel {
            width: 131px;
            height: 45px;
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            border: 1px solid;
            border-color: linear-gradient(90deg, rgba(107, 179, 201, 1), rgba(90, 198, 153, 1)) 1 1;
            font-size: 15px;
            font-family: Century Gothic;
            color: #4D94A0;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-right: 10px;
        }

        .btn_confirm {
            width: 131px;
            height: 47px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 10px;
        }
    }
}

::v-deep .cnt_banner {
    height: 100%;
    margin-top: 390px;
    background: #F3F4F6;
    // border-radius: 20px 20px 0px 0px;
    padding: 9px 19.5008px 0 19.5008px;

    // transform: translateY(-85px);
    .top_title_box {
        font-size: 15px;
        font-family: Century Gothic;
        color: #626262;
    }

    .top_img {
        width: 336px;
        height: 100px;
        // padding: 30.5008px 0 21px 0;
        margin: 0 auto;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .step_box {
        margin-top: 20px;
        // margin-left: 5px;
        // padding-left: 17px;
        padding-top: 5px;
        // border-left: 1px dotted #4D94A0;
        position: relative;
        background: #FFFFFF;
        border-radius: 20px;

        .el-divider--horizontal {
            margin: 0;
        }

        .el-divider {
            background: #E6F0F2;
        }

        .step_box_title {
            font-size: 24px;
            font-family: Arial-BoldMT, Arial;
            font-weight: 600;
            color: #1E1E1E;
            padding: 9px 11.5px;
        }

        .step_img {
            width: 9.5008px;
            height: 9.5008px;
            position: absolute;
            top: -10px;
            left: -5px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .top_step_txt {
            position: absolute;
            left: 16px;
            top: -11px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8F8F8F;
            line-height: 21px;
        }

        .chanoe_box {

            // width: 100%;
            // min-height: 56px;
            // background: #FFFFFF;
            // margin-top: 15px;
            // box-shadow: 0px 2px 14px 0px rgba(29, 85, 79, 0.08);
            // border-radius: 10px;
            .formto_box {
                height: 56px;
                display: flex;
                align-items: center;

                .color_txt {
                    color: #C1C1C1 !important;
                }

                .xu_txt {
                    padding-left: 11px;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4D94A0;
                    line-height: 22.5008px;
                }

                .form_txt {
                    padding-left: 11.5008px;
                    padding-right: 8px;
                    // flex-grow: 4;
                    width: 92px;
                    font-size: 18px;
                    font-family: Arial-BoldMT, Arial;
                    font-weight: normal;
                    color: #1E1E1E;
                    line-height: 47px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                }

                .margin_mg_box {
                    margin-left: 10px;
                }

                .chu_img {
                    position: relative;

                    .feiji_img {
                        width: 47.5008px;
                        height: 13px;
                    }

                    .yonghu_img {
                        width: 22px;
                        height: 22px;
                    }

                    .walk_img {
                        width: 47.5008px;
                        height: 24.5008px;
                    }

                    .car1_img {
                        width: 47.5008px;
                        height: 18px;
                    }

                    .car2_img {
                        width: 47.5008px;
                        height: 21px;
                    }

                    .car3_img {
                        width: 47.5008px;
                        height: 23px;
                    }

                    .motocycle1_img {
                        width: 47.5008px;
                        height: 14px;
                    }

                    .bus1_img {
                        width: 47.5008px;
                        height: 11.5008px;
                    }

                    .rains1_img {
                        width: 47.5008px;
                        height: 18px;
                    }

                    .ferry1_img {
                        width: 47.5008px;
                        height: 15px;
                    }

                    .nter_city_img {
                        width: 47.5008px;
                        height: 12px;
                    }
                }

                .to_txt {
                    padding-left: 18.5008px;
                    // flex-grow: 4;
                    width: 108px;
                    font-size: 18px;
                    font-family: Arial-BoldMT, Arial;
                    font-weight: normal;
                    color: #1E1E1E;
                    line-height: 47px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .change_box {
                width: 262.5008px;
                height: 31px;
                background: #EDF5F6;
                border-radius: 5px;
                margin-left: 13px;
                transform: translateY(-10px);
                display: flex;
                justify-content: space-between;
                align-items: center;

                .one_div {
                    margin-left: 5px;
                    padding: 0 13px 0 14px;
                }

                .two_div {
                    margin-right: 5px;
                    padding: 0 13px 0 14px;
                }

                .border_box {
                    background: #FFFFFF;
                    border-radius: 5px;

                    div {
                        color: #303236 !important;
                    }
                }

                .change_box_flex {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 24.5008px;

                    img {
                        width: 10.5008px;
                        height: 7.5008px;
                    }

                    div {
                        padding-left: 5px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #8F8F8F;
                        line-height: 16.5008px;
                    }
                }
            }
        }

        .fenge_box {
            padding: 0 14px;

            .fenge_box_flex {
                padding: 12px 0;
                align-items: center;
            }

            .txt_align {
                text-align: right;
            }

            .txt_title {
                font-size: 12px;
                font-family: Century Gothic;
                color: #8F8F8F;
            }

            .txt_txt {
                font-size: 15px;
                font-family: Century Gothic;
                color: #4D94A0;
            }

            .fenge_img {
                display: flex;
                align-items: center;
                justify-content: end;

                img {
                    width: 19px;
                    height: 19px;
                }

            }
        }

        .addrem_box {
            // padding-top: 15.5008px;
            // padding: 15.5px 0;
            padding-bottom: 15.5px;

            // display: flex;
            // justify-content: space-between;
            .img_flex_box {
                margin-top: 15.5px;

                .se_box {
                    text-align: center;

                    img {
                        width: 48px;
                        height: 48px;
                    }

                    .se_tx {
                        font-size: 12px;
                        font-family: Century Gothic;
                        color: #8F8F8F;
                    }
                }
            }

            .add_box {
                display: flex;
                cursor: pointer;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }

                div {
                    font-size: 15px;
                    font-family: Arial-BoldMT, Arial;
                    font-weight: 600;
                    color: #303236;
                    line-height: 17px;
                }
            }

            NaNpx_txt {
                cursor: pointer;
                font-size: 15px;
                font-family: Century Gothic;
                color: #4D94A0;
                line-height: 17px;
            }
        }

        .step_btm_img {
            width: 9.5008px;
            height: 9.5008px;
            position: absolute;
            bottom: 5px;
            left: -5px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .step_btm_box {
            display: flex;
            padding-top: 35.5008px;
            transform: translateY(5px);
            justify-content: space-between;

            div {
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #8F8F8F;
                // line-height: 21px;
            }

            .el-checkbox__input.is-checked .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background-color: #4D94A0;
                border-color: #4D94A0;
            }

            .el-checkbox__inner {
                border-color: #4D94A0;
            }

            .el-checkbox__inner:hover {
                border-color: #4D94A0;
            }

            .el-checkbox__input.is-checked+.el-checkbox__label {
                color: #000000;
            }
        }
    }

    .btm_formto_box {
        // transition: all 1s ease-in 0ms;
        padding-left: 21px;

        .chanoe_box {
            width: 100%;
            min-height: 56px;
            background: #FFFFFF;
            margin-top: 15px;
            box-shadow: 0px 2px 14px 0px rgba(29, 85, 79, 0.08);
            border-radius: 10px;

            .formto_box {
                height: 56px;
                display: flex;
                align-items: center;

                .color_txt {
                    color: #C1C1C1 !important;
                }

                .xu_txt {
                    padding-left: 11px;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4D94A0;
                    line-height: 22.5008px;
                }

                .form_txt {
                    padding-left: 11.5008px;
                    // flex-grow: 4;
                    width: 92px;
                    padding-right: 8px;
                    font-size: 18px;
                    font-family: Arial-BoldMT, Arial;
                    font-weight: normal;
                    color: #1E1E1E;
                    line-height: 47px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .chu_img {
                    position: relative;

                    .feiji_img {
                        width: 47.5008px;
                        height: 13px;
                    }

                    .walk_img {
                        width: 47.5008px;
                        height: 24.5008px;
                    }

                    .car1_img {
                        width: 47.5008px;
                        height: 18px;
                    }

                    .car2_img {
                        width: 47.5008px;
                        height: 21px;
                    }

                    .car3_img {
                        width: 47.5008px;
                        height: 23px;
                    }

                    .motocycle1_img {
                        width: 47.5008px;
                        height: 14px;
                    }

                    .bus1_img {
                        width: 47.5008px;
                        height: 11.5008px;
                    }

                    .rains1_img {
                        width: 47.5008px;
                        height: 18px;
                    }

                    .ferry1_img {
                        width: 47.5008px;
                        height: 15px;
                    }

                    .nter_city_img {
                        width: 47.5008px;
                        height: 12px;
                    }
                }

                .to_txt {
                    padding-left: 18.5008px;
                    // flex-grow: 4;
                    width: 108px;
                    font-size: 18px;
                    font-family: Arial-BoldMT, Arial;
                    font-weight: normal;
                    color: #1E1E1E;
                    line-height: 47px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .change_box {
                width: 262.5008px;
                height: 31px;
                background: #EDF5F6;
                border-radius: 5px;
                margin-left: 13px;
                transform: translateY(-10px);
                display: flex;
                justify-content: space-between;
                align-items: center;

                .one_div {
                    margin-left: 5px;
                    padding: 0 13px 0 14px;
                }

                .two_div {
                    margin-right: 5px;
                    padding: 0 13px 0 14px;
                }

                .border_box {
                    background: #FFFFFF;
                    // padding: 0 13px 0 14px;
                    border-radius: 5px;

                    div {
                        color: #303236 !important;
                    }
                }

                .change_box_flex {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 24.5008px;

                    img {
                        width: 10.5008px;
                        height: 7.5008px;
                    }

                    div {
                        padding-left: 5px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #8F8F8F;
                        line-height: 16.5008px;
                    }
                }
            }
        }

        .addrem_box {
            padding-top: 15.5008px;
            display: flex;
            justify-content: space-between;

            .add_box {
                display: flex;
                cursor: pointer;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }

                div {
                    font-size: 15px;
                    font-family: Arial-BoldMT, Arial;
                    font-weight: 600;
                    color: #303236;
                    line-height: 17px;
                }
            }

            NaNpx_txt {
                cursor: pointer;
                font-size: 15px;
                font-family: Century Gothic;
                color: #4D94A0;
                line-height: 17px;
            }
        }
    }

    .display_box {
        display: block;
    }

    .display_none {
        display: none;
    }

    .btm_btn_box {
        width: 336px;
        margin: 40px auto;
        background: #FFFFFF;
        box-shadow: 0px 2px 25px 0px rgba(15, 95, 75, 0.08);
        border-radius: 20px;

        .top_img {
            width: 336px;
            height: 100px;
            // padding: 30.5008px 0 21px 0;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .banner_box {
            padding: 10.5008px 16px 29.5008px 12.5008px;

            .addrem_box {
                padding-top: 15.5008px;
                display: flex;
                justify-content: space-between;

                .add_box {
                    display: flex;
                    cursor: pointer;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 10px;
                    }

                    div {
                        font-size: 15px;
                        font-family: Arial-BoldMT, Arial;
                        font-weight: 600;
                        color: #303236;
                        line-height: 17px;
                    }
                }

                NaNpx_txt {
                    cursor: pointer;
                    font-size: 15px;
                    font-family: Century Gothic;
                    color: #4D94A0;
                    line-height: 17px;
                }
            }

            .city_box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #E6F0F2;

                .xu_txt {
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4D94A0;
                    line-height: 22.5008px;
                }

                .city_txt {
                    flex-grow: 5;
                    padding-left: 11.5008px;

                    .el-input__inner {
                        border: none;
                        font-size: 18px;
                        font-family: Arial-BoldMT, Arial;
                        font-weight: normal;
                        color: #1E1E1E;
                        line-height: 47px;
                        padding: 0;
                    }
                }

                .add_box {
                    display: flex;
                    align-items: center;

                    img {
                        width: 30px;
                        height: 30px;
                    }

                    div {
                        padding: 0 13px 0 13px;
                        font-size: 15px;
                        font-family: Century Gothic;
                        color: #303236;
                        line-height: 17px;
                    }
                }

                .nig_txt {
                    padding-left: 15px;
                    font-size: 13px;
                    font-family: Century Gothic;
                    color: #8F8F8F;
                    line-height: 15.5008px;
                }
            }
        }
    }

    .btm_btns {
        margin-top: 40px;
        margin-bottom: 20px;

        div {
            cursor: pointer;
            height: 45px;
            // background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            border: 1px solid #4D94A0;
            text-align: center;
            line-height: 45px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #4D94A0;
        }
    }

    .btm_btn {
        // margin-top: 40px;
        padding-bottom: 40px;

        div {
            cursor: pointer;
            height: 45px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            text-align: center;
            line-height: 45px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
        }
    }
}

::v-deep .el-drawer {
    border-radius: 20px 20px 0px 0px;
}

::v-deep .el-drawer__header {
    margin: 0;
    padding: 19.5008px 19.5008px 0 0;
}

::v-deep .el-icon-close:before {
    display: inline-block;
    width: 19px;
    height: 18.5008px;
    content: "";
    background: url(../assets/img/guanbi.png) no-repeat 0 0;
    background-size: 100%;
}

::v-deep .el-popper .popper__arrow {
    display: none !important;
}

::v-deep .el-autocomplete-suggestion {
    top: auto !important;
    bottom: 176px !important;
    left: auto !important;
    right: auto !important;
}

::v-deep .el-autocomplete-suggestion li {
    opacity: 1 !important;
}

::v-deep .el-autocomplete-suggestion__wrap {
    text-align: left;
}

::v-deep .drawer_formto {
    .drawer_banner {
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303236;
        line-height: 25px;

        .drawer_content {
            margin-top: 31px;
            padding: 0 20px 0 20px;

            .el-divider--horizontal {
                padding: 0;
                margin: 13px 0 0 0;
            }

            .diawer_flex {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 11.5008px;

                .diawer_flex_flex {
                    display: flex;
                    align-items: center;

                    div {

                        font-size: 15px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #303236;
                        line-height: 21px;
                    }

                    .feiji_img {
                        width: 24.5008px;
                        height: 13px;
                        padding-right: 22.5008px;
                    }

                    .walk_img {
                        width: 14.5008px;
                        height: 24.5008px;
                        padding-right: 30.5008px;
                    }

                    .car_img {
                        width: 20.5008px;
                        height: 18px;
                        padding-right: 25.5008px;
                    }

                    .car1_img {
                        width: 21px;
                        height: 21px;
                        padding-right: 25.5008px;
                    }

                    .car2_img {
                        width: 21px;
                        height: 16px;
                        padding-right: 25.5008px;
                    }

                    .moto_img {
                        width: 26.5008px;
                        height: 14px;
                        padding-right: 21.5008px;
                    }

                    .bus_img {
                        width: 30.5008px;
                        height: 11.5008px;
                        padding-right: 17.5008px;
                    }

                    .rain_img {
                        width: 14px;
                        height: 18px;
                        padding-right: 33.5008px;
                    }

                    .ferry_img {
                        width: 21.5008px;
                        height: 15px;
                        padding-right: 26.5008px;
                    }

                    .nter_img {
                        width: 31px;
                        height: 12px;
                        padding-right: 17.5008px;
                    }
                }

                .duihao_img {
                    width: 19px;
                    height: 13px;
                }
            }
        }
    }

    .ipt_box {
        margin-top: 30px;

        .el-autocomplete {
            width: 333px;

            .el-input__inner {
                height: 49px;
                line-height: 49px;
                border: none;
                background: #F8F8F8;
                border-radius: 5px;
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #303236;
                line-height: 21px;
            }
        }
    }

    .btn_box {
        margin-top: 39px;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
            width: 335px;
            height: 45px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            display: flex;
            align-items: center;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            justify-content: center;
        }

    }
}

::v-deep .ipt_btm_box {
    display: flex;
    align-items: center;

    .nig_txt {
        padding-left: 15px;
        font-size: 13px;
        font-family: Century Gothic;
        color: #8F8F8F;
        line-height: 15.5008px;
    }

    .el-input__inner {
        border: none;
        font-size: 1.125rem;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #1E1E1E;
        line-height: 2.9375rem;
        padding: 0;
    }
}

::v-deep .txt_ipt {
    .el-input__inner {
        text-align: right;
    }
}
</style>
